import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 1C5.92487 1 1 5.92486 1 12C1 14.6615 1.94632 17.1038 3.51936 19.006L1.30049 23H12C18.0751 23 23 18.0751 23 12C23 5.92486 18.0751 1 12 1ZM10.1135 8.83325L9.78021 9.77609L7.89453 9.1096L8.22778 8.16675C8.77642 6.61451 10.2567 5.5 11.9999 5.5C14.2091 5.5 15.9999 7.29086 15.9999 9.5C15.9999 10.7759 15.4014 11.9125 14.4739 12.6433C14.0423 12.9834 13.657 13.3088 13.378 13.6519C13.1034 13.9896 12.9999 14.262 12.9999 14.5V15.75H10.9999V14.5C10.9999 13.6334 11.3901 12.9265 11.8262 12.3902C12.2579 11.8592 12.8001 11.4159 13.2361 11.0723C13.7031 10.7045 13.9999 10.1372 13.9999 9.5C13.9999 8.39543 13.1045 7.5 11.9999 7.5C11.1307 7.5 10.3885 8.0551 10.1135 8.83325ZM13.0036 16.75V18.7539H10.9997V16.75H13.0036Z"}}]};

const ChatBubbleHelpFilled = Vue.extend<IconProps>({
  name: 'ChatBubbleHelpFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'chat-bubble-help-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ChatBubbleHelpFilled;
